import { ContextlessQueryObserverOptions } from '@frontend/react-query-helpers';

export const defaultOptions: ContextlessQueryObserverOptions = {
  refetchOnMount: true,
  refetchOnWindowFocus: false,
};
